import { TrackApi } from "../../Types/Generated/LogbookApi/TrackApi"
import { entity } from "./Connection"

// Track's typed day/trip/Cruise fetcher. The bound owner id selects the matching route;
// tracks stay unsorted, live-updated and non-soft-deletable.
export const TrackEntity = entity("Track", {
  fetch: (client, ids) => {
    const { shipId, cruiseId, dayId, tripId } = ids;
    if (shipId === undefined) {
      return Promise.reject(new Error("Track fetch requires shipId"));
    }
    const request = dayId !== undefined
      ? new TrackApi(client).tracks.day({ params: { shipId, dayId } }).call()
      : tripId !== undefined
        ? new TrackApi(client).tracks.trip({ params: { shipId, tripId } }).call()
        : cruiseId !== undefined
          ? new TrackApi(client).tracks.cruise({ params: { shipId, cruiseId } }).call()
          : Promise.reject(new Error("Track fetch requires cruiseId, dayId or tripId"));
    return request.then((r) => ({
      entities: { Track: r.tracks ?? [] },
      // anchorCircles have no id — they're not a persisted schema entity, so they
      // ride the fetch as view-local extras (like logs.list's auditLogEdits).
      extras: { anchorCircles: r.anchorCircles ?? [] },
    }));
  },
});
